/**
 * @component Card
 * @description Basis-Karten-Container nach Design-Standard (Border, kein Shadow).
 * Unterstuetzt Titel, Untertitel, Actions und verschiedene Padding-Groessen.
 *
 * @prop {string}    [title]     - Kartentitel
 * @prop {string}    [subtitle]  - Optionaler Untertitel
 * @prop {ReactNode} [actions]   - Aktionselemente (rechts oben)
 * @prop {ReactNode} children    - Karteninhalt
 * @prop {string}    [className] - Optionale CSS-Klassen
 * @prop {string}    [padding='md'] - Innenabstand (sm, md, lg)
 * @prop {boolean}   [hover=false]  - Ob Hover-Effekt aktiv ist
 * @usage Universeller Container auf allen Seiten
 */
const PADDING = {
  sm: 'p-3',
  md: 'px-6 py-5',
  lg: 'p-7',
};

export function Card({ title, subtitle, actions, children, className = '', padding = 'md', hover = false, ...props }) {
  return (
    <div className={`bg-surface-card border border-line-card rounded-card shadow-card ${hover ? 'hover:shadow-card-hover hover:border-line-hover transition-all' : ''} ${PADDING[padding] || PADDING.md} ${className}`} {...props}>
      {(title || subtitle || actions) && (
        <div className={`flex items-start justify-between ${children ? 'mb-4' : ''}`}>
          <div>
            {title && (
              <h3 className="text-sm font-semibold text-content">{title}</h3>
            )}
            {subtitle && <p className="text-xs text-content-secondary mt-0.5">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
